import EventsPlus from './EventsPlus'

export default EventsPlus
// eslint-disable-next-line import/export
export * from './EventsPlus'
